import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ChangePasswordComponent } from './change-password.component';
import { SharedModule } from 'app/shared/shared.module';

const routes = [
    {
        path     : 'auth/change-password',
        component: ChangePasswordComponent
    }
];

@NgModule({
    declarations: [ChangePasswordComponent],
    imports: [
        RouterModule.forChild(routes),
        SharedModule
  ]
})
export class ChangePasswordModule { }
